import { CartesianProduct } from 'js-combinatorics/commonjs/combinatorics';
import { TAffixLevelRange } from '../../gameConfig/mythicPlus';

export function generateAllAffixPermutations(affixRotations: TAffixLevelRange[]): number[][] {
  const permutations: number[][][] = [];

  for (let i = 0; i < affixRotations.length; ++i) {
    const keyLevel = affixRotations[i].min;

    // only look at affixes that match this key level
    const filteredAffixes = affixRotations.filter((rotation) => {
      return keyLevel >= rotation.min && (!rotation.max || keyLevel <= rotation.max);
    });

    // build all the possible combinations of affixes
    const product = new CartesianProduct(...filteredAffixes.map((group) => group.affixes));

    permutations.push(
      product.toArray().filter(
        (group: number[]) =>
          // remove any combos with repeated affixes, since cartesian product will
          // combine the affix ranges of fort/tyran and tyran/fort in such a way
          // that you'd get fort+fort and tyran+tyran on keys.
          group.length === new Set(group).size
      )
    );
  }

  return permutations.flat();
}
